import { unspecifiedDateToMillis } from 'utils/dateManagement';
import * as server from './server';

export async function resourceRequest({ data, action }) {
  const response = await executeBodyRequest({
    method: 'POST',
    url: `${server.Config.apiUrl}${`/resources/v1/${action}`}`,
    body: JSON.stringify(data || {}),
  });

  if (!response || !response.result) {
    return null;
  }

  if (typeof response.result === 'string') {
    if (action === 'find') {
      return {
        ...response,
        result: JSON.parse(response.result),
      };
    }

    return JSON.parse(response.result);
  }

  return response.result;
}

export async function functionRequest({ functionName, data }) {
  const response = await executeBodyRequest({
    method: 'POST',
    url: `${server.Config.apiUrl}/functions/invoke`,
    body: JSON.stringify({
      functionName,
      data,
    }),
  });

  if (!response) {
    return null;
  }

  if (response.result) {
    return response.result;
  }

  return response;
}

export async function postLogin({ path, data }) {
  const response = await executeBodyRequest({
    method: 'POST',
    allowAnonymous: true,
    url: `${server.Config.apiUrl}${path}`,
    body: JSON.stringify(data || {}),
  });

  return response;
}

export async function postFile({ file, resource, fieldPath }) {
  const formData = new FormData();

  if (fieldPath != null && fieldPath !== undefined) {
    formData.append('fieldPath', fieldPath);
  }

  formData.append('data', file);
  formData.append('resource', resource);

  const response = await executeBodyRequest({
    method: 'POST',
    url: `${server.Config.apiUrl}/files`,
    body: formData,
  });

  return response;
}

export async function getFileUrlByFileId({ fileId }) {
  const response = await executeBodyRequest({
    method: 'GET',
    url: `${server.Config.apiUrl}/files/url-by-id?fileId=${fileId}`,
  });

  return response;
}

export async function getProfileRequest() {
  const response = await executeBodyRequest({
    method: 'GET',
    url: `${server.Config.apiUrl}/users/v1/profile`,
  });

  return response;
}

export async function changePasswordRequest({ password, newPassword }) {
  const response = await executeBodyRequest({
    method: 'POST',
    url: `${server.Config.apiUrl}/users/v1/change-password`,
    body: JSON.stringify({ password, newPassword }),
  });

  return response;
}

export async function createPasswordResetRequest({ email }) {
  const response = await executeBodyRequest({
    method: 'POST',
    url: `${server.Config.apiUrl}/users/v1/create-password-reset`,
    body: JSON.stringify({ email }),
    allowAnonymous: true,
  });

  return response;
}

export async function resetPasswordRequest({ password, token }) {
  const response = await executeBodyRequest({
    method: 'POST',
    url: `${server.Config.apiUrl}/users/v1/reset-password`,
    body: JSON.stringify({ password, token }),
    allowAnonymous: true,
  });

  return response;
}

async function resolveAuth() {
  const tokenV2Json = localStorage.getItem('tokenV2');

  if (!tokenV2Json) {
    throw new Error('Unauthorized');
  }

  const tokenV2 = JSON.parse(tokenV2Json);

  const accessTokenMillis = unspecifiedDateToMillis(tokenV2.accessExpires);
  const currentMillis = unspecifiedDateToMillis(new Date()) + 300000;

  if (accessTokenMillis < currentMillis) {
    try {
      const refreshResponse = await server.loadJson(`${server.Config.apiUrl}/users/v1/refresh`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Client-Type': 'Admin',
        },
        body: JSON.stringify({ refreshToken: tokenV2.refreshToken }),
      });

      localStorage.setItem('tokenV2', JSON.stringify(refreshResponse));
      return refreshResponse.accessToken;
    } catch (e) {
      if (e.status === 403) {
        window.location.href = '/login';
      }
    }
  }

  return tokenV2.accessToken;
}

async function executeBodyRequest({ allowAnonymous, url, body, method }) {
  const token = allowAnonymous ? null : await resolveAuth();

  const headers = {
    Accept: 'application/json',
    'X-Client-Type': 'Admin',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (typeof body === 'string') {
    headers['Content-Type'] = 'application/json';
  }

  const response = await server.loadJson(url, {
    method,
    headers,
    body,
  });

  return response;
}
